import MainMenu from './main-menu';


export default (di) => {
	di.setType({type: MainMenu, name: 'MainMenu', parent: 'PageComponent'});
};
